import { IconSvgProps } from "../types";

export const Lightning = ({ size }: IconSvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 36 36"
        width={size}
        height={size}
    >
        <path
            style={{
                fillRule: "evenodd"
            }}
            d="M29.12 13.67h-8L22.8 1.2a1 1 0 0 0-1.88-.77L6 20.65a1.06 1.06 0 0 0 .85 1.68h8.05L13.2 34.8a1 1 0 0 0 1.88.77L30 15.35a1.06 1.06 0 0 0-.88-1.68Z"
        />
    </svg>
);
